var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missing-page"},[_c('p',[_vm._v("You typed "+_vm._s(_vm.$route.path))]),_c('p',[_vm._v("We don't have a page for that. Shrug!")])])}
var staticRenderFns = []

export { render, staticRenderFns }